import { Route } from '@angular/router';
import { FilterListComponent } from 'src/app/pages/datasets/filter-list/filter-list.component';
import { FilterDetailsComponent } from 'src/app/pages/datasets/filter-details/filter-details.component';
import { FilterEditComponent } from 'src/app/pages/datasets/filter-edit/filter-edit.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { CullCategoriesComponent } from '../../../../../pages/datasets/filter-categories/cull-categories.component';

export const filters: Route = {
  path: 'filters',
  title: 'nav.datasets.culls',
  data: {
    icon: SbIcons.selection,
    breadcrumb: 'nav.datasets.culls',
    id: RoutingID.filters,
  },
  children: [
    {
      path: '',
      component: FilterListComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'filter-edit/:filterID',
      title: 'nav.datasets.culls.edit',
      data: {
        breadcrumb: 'nav.datasets.culls.edit',
        icon: SbIcons.edit,
        id: RoutingID.filterEdit,
      },
      children: [
        {
          path: '',
          component: FilterEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'cull-categories',
      title: 'lang.globals.cullCategories',
      data: {
        breadcrumb: 'lang.globals.cullCategories',
        icon: SbIcons.category,
        id: RoutingID.cullCategories,
      },
      children: [
        {
          path: '',
          component: CullCategoriesComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'filter-details/:filterID',
      title: 'nav.datasets.culls.details',
      data: {
        breadcrumb: 'nav.datasets.culls.details',
        icon: SbIcons.details,
        id: RoutingID.filterDetails,
      },
      children: [
        {
          path: '',
          component: FilterDetailsComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'filter-create',
      title: 'nav.datasets.culls.create',
      data: {
        breadcrumb: 'nav.datasets.culls.create',
        icon: SbIcons.plus,
        id: RoutingID.filterCreate,
      },
      children: [
        {
          path: '',
          component: FilterEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
